import request from "@/utils/request";
import config from "@/config";
let serveUrl = config.baseUrl;
// let serveUrl = 'http://192.168.2.59:20001';

let personalCenterBaseUrl = config.personalCenterBaseUrl;

let adminCenterUrl = config.adminCenterUrl;

// 获取详情
export function getPersonalDetail(data) {
  return request({
    url: `https://portal-service-test.sufe.edu.cn/portalCenter/api/rest/center/personalData/detail/getpersonalDataDetails`,
    method: "get",
		params: data
  });
}
//决策管理保存

export function saveOrUpdateMenu(data) {
  return request({
    url: `https://portal-service-test.sufe.edu.cn/portalCenter/api/open/v1/menu/saveOrUpdateMenu`,
    method: 'post',
    data: data
  })
}



// 获取list
export function getMenuList(data) {
  return request({
    url: `https://portal-service-test.sufe.edu.cn/portalCenter/api/open/v1/menu/getMenuList?pageNum=1&pageSize=10`,
    method: 'get',
    params: data
  })
}



export function getMenuById(data){
  return request({
    url: `https://portal-service-test.sufe.edu.cn/portalCenter/api/open/v1/menu/getMenuById`,
    method: 'get',
    params: data
  })
}

// 删除
export function deleteMenuById(data){
  return request({
    url: `https://portal-service-test.sufe.edu.cn/portalCenter/api/open/v1/menu/deleteMenuById`,
    method: 'get',
    params: data
  })
}
// 获取所有部门
export function getOrganizationTree() {
  return request({
    url: `https://admin-center-test.sufe.edu.cn/api/v1/base/organization/organizationTree`,
    method: "get",
    headerType: "portal"
  });
}
// 获取所有用户组
export function getGroupTree() {
  return request({
    url: `https://admin-center-test.sufe.edu.cn/api/v1/base/group`,
    method: "get",
    headerType: "portal"
  });
}

// 获取所有角色
export function getRoleTree() {
  return request({
    url: `https://portal-service-test.sufe.edu.cn/v1/role/findAll`,
    method: "get",
    headerType: "portal"
  });
}